// 'use client';
// import { useState } from 'react';
// import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

// const faqs = [
//   {
//     question: 'How does MashonaDev ensure developer quality?',
//     answer: 'All developers undergo rigorous technical screenings and soft-skills assessments.'
//   },
//   {
//     question: 'What passive income opportunities exist for students?',
//     answer: 'Students earn passive income through gamified tech tasks assigned to them. It\'s a play-and-earn approach.'
//   },
//   {
//     question: 'How do businesses request services?',
//     answer: 'You can book a consultation with us from our contact us page so we can discuss what you need us to do for you.'
//   },
//   {
//     question: 'How much is MashonaDev consultation fee?',
//     answer: 'Free for first-time clients, but for returning clients, consultation is $100.'
//   }
// ];

// const FAQSection = () => {
//   const [openIndex, setOpenIndex] = useState<number | null>(null);

//   interface FAQ {
//     question: string;
//     answer: string;
//   }

//   const toggleFAQ = (index: number): void => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   return (
//     <section className="py-16 px-4 bg-white">
//       <div className="container mx-auto max-w-[500px]">
//         <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-left sm:text-center lg:text-center mb-4 text-black">Frequently Asked Questions</h2>
//         <p className="text-left font-normal text-gray-700 mb-8 lg:text-center lg:font-semibold ">See our FAQ section and find answers to all your questions and more!</p>
//         <div className=" mx-auto">
//           {faqs.map((faq, index) => (
//             <div key={index} className="border border-gray-300 rounded-lg mb-4 overflow-hidden">
//               <button
//                 className="w-full flex items-center justify-between p-4 text-left text-black text-base lg:text-lg font-normal cursor-pointer"
//                 onClick={() => toggleFAQ(index)}
//               >
//                 {faq.question}
//                 {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
//               </button>
//               {openIndex === index && (
//                 <div className="px-4 pb-4 text-gray-600 text-sm lg:text-base">{faq.answer}</div>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FAQSection;




'use client';
import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { AnimatePresence, motion } from 'framer-motion';

const faqs = [
  {
    question: 'How does MashonaDev ensure developer quality?',
    answer: 'All developers undergo rigorous technical screenings and soft-skills assessments.'
  },
  {
    question: 'What passive income opportunities exist for students?',
    answer: 'Students earn passive income through gamified tech tasks assigned to them. It\'s a play-and-earn approach.'
  },
  {
    question: 'How do businesses request services?',
    answer: 'You can book a consultation with us from our contact us page so we can discuss what you need us to do for you.'
  },
  {
    question: 'How much is MashonaDev consultation fee?',
    answer: 'For returning clients, consultation is $100, but free for first-time clients.'
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number): void => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 px-4 bg-white">
      <div className="container mx-auto max-w-[500px]">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-left sm:text-center lg:text-center mb-4 text-black">
          Frequently Asked Questions
        </h2>
        <p className="text-left font-normal text-gray-700 mb-8 lg:text-center lg:font-semibold">
          See our FAQ section and find answers to all your questions and more!
        </p>
        <div className="mx-auto">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-300 rounded-lg mb-4 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 text-left text-black text-base lg:text-lg font-normal cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
              </button>
              <AnimatePresence initial={false}>
                {openIndex === index && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                    className="px-4 pb-4 text-gray-600 text-sm lg:text-base overflow-hidden"
                  >
                    <div>{faq.answer}</div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
